// extracted by mini-css-extract-plugin
export default {"file-info-panel":"styles_file-info-panel__YEyaJ","group":"styles_group__62ksC","divider":"styles_divider__bt3nc"};